import { inkBadgeTokens } from '@ds/tokens'

const tokens = {
  backgroundColor: inkBadgeTokens.badgeStatusBgColorAlert,
  borderColor: inkBadgeTokens.badgeAlertBorderColorDefault,
} as const

export default tokens
